import { Component, Input, Output, SimpleChanges, EventEmitter, OnChanges, signal } from '@angular/core';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-drivers-salary-days-list',
	templateUrl: './drivers-salary-days-list.component.html',
	styleUrls: ['./drivers-salary-days-list.component.css'],
})
export class DriversSalaryDaysListComponent implements OnChanges {
	@Input() driver;
	@Input() selectedMonth;
	@Output() changeMonth = new EventEmitter();
	@Output() sendDriverData = new EventEmitter();
	@Output() sendBonusData = new EventEmitter();
	@Output() sendSalaryBasicData = new EventEmitter();

	loader = new LoaderService();

	data = [];
	bonus;
	salary;
	headers = [
		{ label: 'Dzień' },
		{ label: 'Pojazd' },
		{ label: 'Wydarzenie' },
		{ label: 'Od' },
		{ label: 'Do' },
		{ label: 'Zatw' },
		{ label: 'Stawka' },
		{ label: 'Liczyć' },
		{ label: 'Dieta' },
		{ label: 'Wynagrodzenie' },
		{ label: 'Dodatek/potrącenie' },
		{ label: 'Komentarz' },
	];
	ratesKind: Array<any> = [
		{ id: 0, name: '' },
		{ id: 1, name: 'Jezdna' },
		{ id: 2, name: 'Leżona' },
		{ id: 3, name: 'Inna' },
	];
	diets: Array<any> = [
		{ value: 0, name: '(brak)' },
		{ value: 38, name: 'Polska(stara)', disabled: true },
		{ value: 45, name: 'Polska', disabled: false },
		{ value: 50, name: 'Zagraniczna', disabled: false },
	];

	readonly toggleAllCalculate = signal(false);

	readonly COUNTING_LABEL = 'Liczyć';

	constructor(
		protected api: Data2Service,
		protected infobox: InfoboxService,
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes) {
			this.loader.show();
			this.api.get(`/driversSalaryDays/?driver=${this.driver}&day=${this.selectedMonth}`, (result, error) => {
				if (error) {
					return;
				}
				this.data = this.convertData(result.data.data);
				this.checkToggleAll();
				this.bonus = result.data.salaryBonus;
				this.salary = result.data.salaryBasic;
				this.sendBonusData.emit(this.bonus);
				this.sendDriverData.emit(this.data);
				this.sendSalaryBasicData.emit(this.salary);
				this.loader.hide();
			});
		}
	}

	submit() {
		this.api.command(`/driversSalaryDays/`, { cmd: 'listEdit', set: this.data }, (result, error) => {
			this.loader.show();
			if (error) {
				return;
			}
			this.loader.hide();
			this.infobox.success('Zapisano');
		});
	}

	toggleAllIfNeeded(isToggle: boolean): void {
		this.toggleAllCalculate.set(isToggle);
		this.data?.forEach((item) => {
			item.isCalculate = this.toggleAllCalculate();
		});
	}

	checkToggleAll(): void {
		const isAlreadyToggle = this.data.every((v) => !!v.isCalculate);
		this.toggleAllCalculate.set(isAlreadyToggle);
	}

	protected checkDuplicatesDate(data) {
		const object = {};
		const result = [];

		data.forEach((item) => {
			if (!object[item.day]) object[item.day] = 0;
			object[item.day] += 1;
		});

		for (const i in object) {
			if (object[i] >= 2) {
				result.push(i);
			}
		}
		return result;
	}

	protected convertData(data) {
		data.forEach((obj) => {
			obj.haveDuplicateDay = this.checkDuplicatesDate(data).includes(obj.day) ? true : false;
			obj.confirmed = obj.confirmed == 1 ? true : false;
			obj.isCalculate = obj.isCalculate == 1 ? true : false;
			obj.internationalDiet = obj.internationalDiet == 1 ? true : false;
			obj.polishDiet = obj.polishDiet == 1 ? true : false;
			const rateKind = this.ratesKind.find((objfind) => objfind.id == obj.type);
			obj.rateKind_name = obj.type ? rateKind.name : '';
		});
		return data;
	}
}
